import { ConfigService } from './base-services/config.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'yt-fw-yt-ng-framework',
  template: `
    <p>
      yt-ng-framework works!{{configService.GetApiUrl()}}
    </p>
  `,
  styles: []
})
export class YtNgFrameworkComponent implements OnInit {

  constructor(public configService: ConfigService) { }

  ngOnInit() {
  }

}
